var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rb-header-base-side-panel",
    _vm._b(
      {
        staticClass: "rb-header-account-side-panel",
        attrs: {
          variant: "accountPanel",
          "wcag-hidden-button-is-focusable": _vm.wcagHiddenButtonIsFocusable,
        },
        on: { overlayClicked: _vm.closePanel },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "account-panel__sections" }, [
                  _c(
                    "ul",
                    { staticClass: "account-panel__section" },
                    [
                      _c("li", { staticClass: "section__title" }, [
                        _c(
                          "span",
                          { staticClass: "common__icon common__icon--account" },
                          [_vm._v("account")]
                        ),
                        _vm._v(
                          "\n          " + _vm._s(_vm.panelTitle) + "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isUserLoggedIn
                        ? _vm._l(_vm.menuItems, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "section__item",
                                class: {
                                  "section__item--red": item.color === "red",
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: item.url,
                                      "data-element-id": item.analytics,
                                    },
                                  },
                                  [_vm._v(_vm._s(item.title) + " ")]
                                ),
                              ]
                            )
                          })
                        : [
                            _c("li", { staticClass: "section__item" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.headerLoginPageUrl,
                                    "data-element-id":
                                      "X_X_MainNav_Account_LoginRegister",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translation("common.action_login")
                                    ) + "\n            "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "account-panel__section" },
                    [
                      _c(
                        "li",
                        { staticClass: "section__title" },
                        [
                          _c("rb-lazy-icon", {
                            attrs: { icon: "heart", text: "heart" },
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.translation("common.action_wishlist")
                              ) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("rb-header-wishlist"),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "rb-header-base-side-panel",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }